import { render, staticRenderFns } from "./PopCoursePlayer.vue?vue&type=template&id=25ae9d6a&lang=pug"
import script from "./PopCoursePlayer.vue?vue&type=script&lang=js"
export * from "./PopCoursePlayer.vue?vue&type=script&lang=js"
import style0 from "./PopCoursePlayer.vue?vue&type=style&index=0&id=25ae9d6a&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports